/**
 * Los retratos del equipo.
 *
 * Son los MISMOS ficheros que usa el panel de Word (`addin/src/assets/equipo/<id>.webp`), copiados
 * aquí porque cada producto se construye por su cuenta. Si algún día se rehacen, hay que copiarlos
 * a los dos sitios: un colaborador con dos caras según por dónde le hables no es un colaborador.
 *
 * Cargados con import.meta.glob para no mantener dieciocho imports a mano: añadir un retrato es
 * soltar el .webp. Si falta, `caraDe` devuelve null y quien lo pinte cae a las iniciales — un
 * retrato ausente no puede romper la barra.
 */
// UN RETRATO PRESTADO. `kdp-audit.webp` (Auditor de fichas KDP) es `auditor.webp` (Auditor de
// autoría) reflejado en el eje vertical: era el único colaborador sin cara y salía con iniciales
// en medio de diecisiete retratos. Se dice aquí porque si no, dentro de seis meses, el parecido
// entre los dos auditores parece un fallo de recorte en vez de una decisión.
const ficheros = import.meta.glob("./assets/equipo/*.webp", { eager: true, query: "?url", import: "default" });

const POR_ID: Record<string, string> = {};
for (const [ruta, url] of Object.entries(ficheros)) {
  POR_ID[ruta.split("/").pop()!.replace(".webp", "")] = url as string;
}

export function caraDe(id: string | undefined): string | null {
  return (id && POR_ID[id]) || null;
}
